import { useEffect } from 'react';
import { getVersionRefreshManager } from '@reflex/ui/client/versionRefresh';

export function useBlockRefresh(id: string, active: boolean): void {
  useEffect(() => {
    const manager = getVersionRefreshManager();
    if (active) {
      manager.addBlocker(id);
    } else {
      manager.removeBlocker(id);
    }
    return () => manager.removeBlocker(id);
  }, [id, active]);
}
